export interface Category {
  id: string;
  nameKey: string;
  link: string;
}

export const categories: Category[] = [
  { id: "shoes", nameKey: "category.shoes", link: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { id: "hoodies", nameKey: "category.hoodies", link: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
  { id: "tshirts", nameKey: "category.tshirts", link: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
  { id: "jackets", nameKey: "category.jackets", link: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
  { id: "pants", nameKey: "category.pants", link: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
  { id: "headwear", nameKey: "category.headwear", link: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
  { id: "sets", nameKey: "category.sets", link: "https://kaspreadsheet.com/search-917/name/Shoes.html" },
  { id: "underwear", nameKey: "category.underwear", link: "https://kaspreadsheet.com/search-918/name/Shoes.html" },
  { id: "jersey", nameKey: "category.jersey", link: "https://kaspreadsheet.com/search-919/name/Shoes.html" },
  { id: "accessories", nameKey: "category.accessories", link: "https://kaspreadsheet.com/search-920/name/Shoes.html" },
  { id: "bags", nameKey: "category.bags", link: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
  { id: "belts", nameKey: "category.belts", link: "https://kaspreadsheet.com/search-922/name/Shoes.html" },
  { id: "perfumes", nameKey: "category.perfumes", link: "https://kaspreadsheet.com/search-923/name/Shoes.html" },
  { id: "other", nameKey: "category.other", link: "https://kaspreadsheet.com/search-924/name/Shoes.html" },
];

export const mainSiteUrl = "https://kaspreadsheet.com";